import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Facebook, ShieldAlert } from 'lucide-react';
import { NAV, SITE } from '@/data/content';

export default function Footer() {
  return (
    <footer className="bg-[#0b2545] text-slate-200 mt-24">
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="h-10 w-10 rounded-md bg-white/10 flex items-center justify-center">
              <ShieldAlert className="h-5 w-5 text-amber-400" />
            </div>
            <div className="font-serif text-lg font-bold">DrugAwarenessUSA.net</div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            A school-based drug and alcohol awareness program by Kress &amp; Associates — educating grades 6–12 on the value of making the right choices.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">Explore</h4>
          <ul className="space-y-2 text-sm">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-slate-400 hover:text-amber-300 transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 mt-0.5 text-amber-400" />
              <span>{SITE.phone}</span>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 mt-0.5 text-amber-400" />
              <span>
                {SITE.address.line1}<br />
                {SITE.address.line2}<br />
                {SITE.address.line3}<br />
                {SITE.address.country}
              </span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">Follow</h4>
          <a
            href={SITE.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-amber-300 transition-colors"
          >
            <Facebook className="h-4 w-4" /> Kress-Associates
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500 gap-2">
          <div>&copy; {new Date().getFullYear()} DrugAwarenessUSA.net — Kress &amp; Associates. All rights reserved.</div>
          <div>Erie, Pennsylvania • USA</div>
        </div>
      </div>
    </footer>
  );
}
